
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import BasePageLayout from '#layouts/BasePageLayout/BasePageLayout';
import DocumentPublished from '#components/common/documentPublished/DocumentPublished';
import dynamic from 'next/dynamic';
import {
  GetAnnouncementDocument,
  GetNavigationDocument,
  GetPageDocument,
  useGetPageQuery,
} from '#types/generated/apollo-client';
import logger from '#utils/logger';
import getRequestLocale from '#utils/getRequestLocale';
import useTranslation from 'next-translate/useTranslation';
import { AllowedLocales } from '#types/generated/graphql-types';
import generateUuid from '#utils/uuid';
import initializeClient from '#providers/apollo/initializeClient';
import addApolloState from '#providers/apollo/addApolloState';

const DialogStart = dynamic(() => import('#modules/dialog-start/DialogStart'), {
  ssr: false,
});

const IndexPage = () => {
  const { lang } = useTranslation();
  // Homepage data is pre-fetched and populated into the Apollo cache upstream
  // (e.g. during SSR/build), so we only ever read from cache here and never
  // trigger a network request — keeps the initial render fast and avoids
  // refetching data we already have.
  const { data } = useGetPageQuery({
    variables: { slug: 'homepage', locale: lang as AllowedLocales },
    initialFetchPolicy: 'cache-only',
    fetchPolicy: 'cache-only',
    nextFetchPolicy: 'cache-only',
  });

  return (
    <BasePageLayout>
      {!!data?.page && (
        <DocumentPublished
          blocks={data.page.document.blocks}
          description={data.page.document.description}
          theme={data.page.document.theme}
          title={data.page.document?.title}
        />
      )}
      <DialogStart />
    </BasePageLayout>
  );
};

 async function _getServerSideProps(context) {
  const { query } = context;
  const remotedev = query.remotedev;
  if (remotedev) {
    if (remotedev === 'reset') {
      context.res.setHeader(
        'Set-Cookie',
        'remotedev=; Path=/; Max-Age=0; HttpOnly'
      );
    } else {
      context.res.setHeader('Set-Cookie', `remotedev=${remotedev}; Path=/;`);
    }
  }

  try {
    const client = initializeClient({
      context,
    });

    //fetch page data
    await Promise.all([
      client.query({
        query: GetPageDocument,
        variables: { slug: 'homepage', locale: getRequestLocale(context) },
      }),
      client.query({
        query: GetAnnouncementDocument,
      }),
      client.query({
        query: GetNavigationDocument,
        variables: { name: 'Main' },
      }),
      client.query({
        query: GetNavigationDocument,
        variables: { name: 'Footer' },
      }),
      client.query({
        query: GetNavigationDocument,
        variables: { name: 'Profile' },
      }),
    ]);

    return addApolloState(client);
  } catch (e) {
    const uuid = generateUuid();

    logger.error('Error on rendering page', {
      uuid,
      url: context.resolvedUrl,
      e,
    });
    context.res.statusCode = 500;

    return { props: { error: uuid } };
  }
}

export default IndexPage;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  